export const typeQuestion = [
  { label: 'Opções', value: '1' },
  { label: 'Texto', value: '2' },
];
